import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_ONBOARDING_PROSPERA = '/spe-n-onboarding-prospera';
let SpeNOnboardingProsperaProxy = class SpeNOnboardingProsperaProxy {
    constructor(api) {
        this.api = api;
    }
    createPreAccount(preAccount) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1`;
        return this.api.post(uri, preAccount);
    }
    updatePreAccount(id, preAccount) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/pre-account/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateBasicInformation(id, basicInformation) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/basic-information/${id}`;
        return this.api.put(uri, basicInformation);
    }
    updatePlanValue(id, planValue) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/plan-value/${id}`;
        return this.api.put(uri, planValue);
    }
    updateOptionPayment(id, optionPayment) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/option-payment/${id}`;
        return this.api.put(uri, optionPayment);
    }
    updateAcceptTherms(id, acceptTherms) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/accept-therms/${id}`;
        return this.api.put(uri, acceptTherms);
    }
    updateUpload(id, upload) {
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/upload/${id}`;
        return this.api.put(uri, upload);
    }
    updateStatus(id, data) {
        const body = {
            status: data,
        };
        const uri = `${SPE_N_ONBOARDING_PROSPERA}/v1/status/${id}`;
        return this.api.put(uri, body);
    }
};
SpeNOnboardingProsperaProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOnboardingProsperaProxy = __decorate([
    Injectable()
], SpeNOnboardingProsperaProxy);

const SPE_VIEW_N_ONBOARDING_PROSPERA = '/spe-view-n-onboarding-prospera';
let SpeViewNOnboardingProsperaProxy = class SpeViewNOnboardingProsperaProxy {
    constructor(api) {
        this.api = api;
    }
    getContract(uuidWhitelabel, uuidAccount) {
        const uri = `${SPE_VIEW_N_ONBOARDING_PROSPERA}/v1/terms/current/white-label/${uuidWhitelabel}/account/${uuidAccount}`;
        return this.api.get(uri);
    }
    getStatus(uuidWhitelabel, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ONBOARDING_PROSPERA}/v1/status/white-label/${uuidWhitelabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getBasicInformation(uuidWhitelabel, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ONBOARDING_PROSPERA}/v1/basic-information/white-label/${uuidWhitelabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getDocusignStatus(uuid) {
        const uri = `${SPE_VIEW_N_ONBOARDING_PROSPERA}/v1/docusign-status/id-nosql/${uuid}`;
        return this.api.get(uri);
    }
};
SpeViewNOnboardingProsperaProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNOnboardingProsperaProxy = __decorate([
    Injectable()
], SpeViewNOnboardingProsperaProxy);

const SPE_VIEW_N_DASHBOARD_CLIENT = '/spe-view-n-dashboard-client';
let SpeViewNDashboardClientProxy = class SpeViewNDashboardClientProxy {
    constructor(api) {
        this.api = api;
    }
    getData(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getDataVirtualBanner(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/data-virtual-banner/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getTotalCashback(uuidAccountPayment, wl) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/total-cashback/account/${uuidAccountPayment}/wl/${wl}`;
        return this.api.get(uri);
    }
    getPaymentsEnergyStatement(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/payments-energy-statement/wl/${uuidWhilabel}/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getConsolidatedEconomy(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/consolidated-economy/wl/${uuidWhilabel}/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getExtractConquests(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/conquests/wl/${uuidWhilabel}/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getListAttendance(wl) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/attendance/white-label/${wl}`;
        return this.api.get(uri);
    }
    getWallet(uuid) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/wallet/${uuid}`;
        return this.api.get(uri);
    }
};
SpeViewNDashboardClientProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNDashboardClientProxy = __decorate([
    Injectable()
], SpeViewNDashboardClientProxy);

const SPE_J_UPLOAD_PROSPERA = '/spe-j-upload-prospera';
let SpeJUploadProsperaProxy = class SpeJUploadProsperaProxy {
    constructor(api) {
        this.api = api;
    }
    uploadResources(file, type) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('typeDocument', type);
        const uri = `${SPE_J_UPLOAD_PROSPERA}/v1/upload/`;
        return this.api.post(uri, formData);
    }
};
SpeJUploadProsperaProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJUploadProsperaProxy = __decorate([
    Injectable()
], SpeJUploadProsperaProxy);

const SPE_N_DASHBOARD_CLIENT = '/spe-n-dashboard-client';
let SpeNDashboardClientProxy = class SpeNDashboardClientProxy {
    constructor(api) {
        this.api = api;
    }
    postSendEmailHelp(wl, accountpayment, data) {
        const uri = `${SPE_N_DASHBOARD_CLIENT}/v1/send-email-help/white-label/${wl}/accountPayment/${accountpayment}`;
        return this.api.post(uri, data);
    }
};
SpeNDashboardClientProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNDashboardClientProxy = __decorate([
    Injectable()
], SpeNDashboardClientProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getWallets(uuidAccount, uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/wallets/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

const SPE_VIEW_N_ACCOUNT$1 = '/spe-n-accounts';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    postWallets(data) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/wallet`;
        return this.api.put(uri, data);
    }
    deleteWallet(uuid) {
        const data = null;
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/wallet/delete/${uuid}`;
        return this.api.put(uri, data);
    }
    postBin(data) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/bin`;
        return this.api.post(uri, data);
    }
};
SpeNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountProxy = __decorate([
    Injectable()
], SpeNAccountProxy);

const SPE_J_FUNDS = '/spe-j-funds';
let SpeJFundsProxy = class SpeJFundsProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckBalanceCashBack(uuidAccountPayment, uuidWhilabel) {
        const uri = `${SPE_J_FUNDS}/api/cash-back/check-balance/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getCheckStatementCashBack(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement-cash-back/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
};
SpeJFundsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJFundsProxy = __decorate([
    Injectable()
], SpeJFundsProxy);

const SPE_J_STATEMENT_KISENSE = '/spe-j-statement-kisense';
let SpeJStatementKisenseProxy = class SpeJStatementKisenseProxy {
    constructor(api) {
        this.api = api;
    }
    postManualCharge(data) {
        const uri = `${SPE_J_STATEMENT_KISENSE}/api/manual/charge`;
        return this.api.post(uri, data);
    }
};
SpeJStatementKisenseProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJStatementKisenseProxy = __decorate([
    Injectable()
], SpeJStatementKisenseProxy);

let UiPxProsperaModule = class UiPxProsperaModule {
};
UiPxProsperaModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNOnboardingProsperaProxy,
            SpeViewNOnboardingProsperaProxy,
            SpeViewNDashboardClientProxy,
            SpeNDashboardClientProxy,
            SpeJUploadProsperaProxy,
            SpeViewNAccountProxy,
            SpeNAccountProxy,
            SpeJFundsProxy,
            SpeJStatementKisenseProxy,
            ConfigService
        ]
    })
], UiPxProsperaModule);

var TypeUpload;
(function (TypeUpload) {
    TypeUpload["CPF"] = "CPF";
    TypeUpload["CNPJ"] = "CNPJ";
    TypeUpload["RESIDENCIAL_CERTIFICATE"] = "RESIDENCIAL_CERTIFICATE";
    TypeUpload["RG"] = "RG";
    TypeUpload["CNH"] = "CNH";
    TypeUpload["SOCIAL_CONTRACT"] = "SOCIAL_CONTRACT";
    TypeUpload["MINUTES_MEETING"] = "MINUTES_MEETING";
    TypeUpload["PROFESSIONAL_CERTIFICATE"] = "PROFESSIONAL_CERTIFICATE";
    TypeUpload["SELF_PHOTO"] = "SELF_PHOTO";
    TypeUpload["ATTORNEY_LETTER"] = "ATTORNEY_LETTER";
    TypeUpload["LAST_ELETRIC_POWER_BILL"] = "LAST_ELETRIC_POWER_BILL";
})(TypeUpload || (TypeUpload = {}));

var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["APROVED"] = "APROVED";
    Status["INACTIVE"] = "INACTIVE";
    Status["IN_ANALYSIS"] = "IN_ANALYSIS";
    Status["REPROVED"] = "REPROVED";
    Status["REPROVED_POLICY"] = "REPROVED_POLICY";
    Status["REPROVED_AVAILABILITY"] = "REPROVED_AVAILABILITY";
    Status["ACCEPT_THERM"] = "ACCEPT_THERM";
})(Status || (Status = {}));

/*
 * Public API Surface of ui-px-prospera
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJFundsProxy, SpeJStatementKisenseProxy, SpeJUploadProsperaProxy, SpeNAccountProxy, SpeNDashboardClientProxy, SpeNOnboardingProsperaProxy, SpeViewNAccountProxy, SpeViewNDashboardClientProxy, SpeViewNOnboardingProsperaProxy, Status, TypeUpload, UiPxProsperaModule };
//# sourceMappingURL=wlp-ui-px-prospera.js.map
